/**
 * 去除按钮的选中
 * @param evt
 */
export function buttonBlur(evt) {
  let target = evt.target;
  if(target.nodeName === "SPAN" || target.nodeName === "I"){
    target = evt.target.parentNode;
  }
  target.blur();
}

/**
 *  隐藏tooltip
 */
export function hideTooltips() {
  let tooltips = document.getElementsByClassName('el-tooltip__popper');
  for(let i = 0; i<tooltips.length; i++){
    tooltips[i].style.display = 'none';
  }
}

/**
 *  进入带tooltip的按钮时，隐藏其他
 * @param evt
 */
export function enterTooltip(evt) {
  if(typeof (evt) != 'undefined') {
    let target = evt.target;
    let buttonClass = target.getAttribute('class'); //el-icon-button
    if(buttonClass && buttonClass.indexOf('el-tooltip') >= 0) {
      hideTooltips();
    }
  }
}

function s4 () {
  return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
}
export function getUUID() {
  return (s4()+s4()+"-"+s4()+"-"+s4()+"-"+s4()+"-"+s4()+s4()+s4());
}

/**
 * 正则只允许输入三位小数
 * @param sourceValue
 * @returns {*}
 */
export function onInputBigDecimal(sourceValue){
  let value = sourceValue;
  if (value != '') {
    value = value.replace(/[^\d.]/g,""); //清除"数字"和"."以外的字符
    value = value.replace(/^\./g,""); //验证第一个字符是数字
    value = value.replace(/\.{2,}/g,"."); //只保留第一个, 清除多余的
    value = value.replace(".","$#$").replace(/\./g,"").replace("$#$",".");
    value = value.replace(/^(-)*(\d+)\.(\d\d\d).*$/,'$1$2.$3'); //只能输入三个小数
  }
  return value
}

/**
 * 判断元素是否出现省略号了
 */
export function isEllipsis(domId){
  let dom = document.getElementById(domId);
  if(dom == null){
      return true;
  }
  let checkDom = dom.cloneNode(), parent, flag;
  checkDom.style.width = dom.offsetWidth + 'px';
  checkDom.style.height = dom.offsetHeight + 'px';
  checkDom.style.overflow = 'auto';
  checkDom.style.position = 'absolute';
  checkDom.style.zIndex = -1;
  checkDom.style.opacity = 0;
  checkDom.style.whiteSpace = "nowrap";
  checkDom.innerHTML = dom.innerHTML;

  parent = dom.parentNode;
  parent.appendChild(checkDom);
  flag = checkDom.scrollWidth > checkDom.offsetWidth;
  parent.removeChild(checkDom);
  return flag;
}